// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"4a7b4fb5","570":"1cb23144","766":"d6160a13","874":"8debec73","950":"6bfd7aa8"}[chunkId] + ".chunk.js";
};